class CartDrawer extends HTMLElement {
  constructor() {
    super();

    this.addEventListener('keyup', (evt) => evt.code === 'Escape' && this.close());
    this.querySelector('#CartDrawer-Overlay').addEventListener('click', this.close.bind(this));
    this.setHeaderCartIconAccessibility();
  }

  setHeaderCartIconAccessibility() {
    const cartLink = document.querySelector('#cart-icon-bubble');
    cartLink.setAttribute('role', 'button');
    cartLink.setAttribute('aria-haspopup', 'dialog');
    cartLink.addEventListener('click', (event) => {
      event.preventDefault();
      this.open(cartLink);
    });
    cartLink.addEventListener('keydown', (event) => {
      if (event.code.toUpperCase() === 'SPACE') {
        event.preventDefault();
        this.open(cartLink);
      }
    });
  }

  open(triggeredBy) {
    if (triggeredBy) this.setActiveElement(triggeredBy);
    const cartDrawerNote = this.querySelector('[id^="Details-"] summary');
    if (cartDrawerNote && !cartDrawerNote.hasAttribute('role')) this.setSummaryAccessibility(cartDrawerNote);
    // here the animation doesn't seem to always get triggered. A timeout seem to help
    setTimeout(() => {
      this.classList.add('animate', 'active');


        // 🔥 Fetch latest cart data and call global logger
    fetch('/cart.js')
      .then(res => res.json())
      .then(cart => {if(typeof window.logCartItems === 'function') {window.logCartItems(cart)}})
      .catch(err => console.error("Cart fetch error:", err));
    });

    this.addEventListener(
      'transitionend',
      () => {
        const containerToTrapFocusOn = this.classList.contains('is-empty')
          ? this.querySelector('.drawer__inner-empty')
          : document.getElementById('CartDrawer');
        const focusElement = this.querySelector('.drawer__inner') || this.querySelector('.drawer__close');
        trapFocus(containerToTrapFocusOn, focusElement);
      },
      { once: true }
    );

    document.body.classList.add('overflow-hidden');
  }

  close() {
    this.classList.remove('active');
    document.body.classList.remove('overflow-hidden');
    removeTrapFocus(this.activeElement);
    var input = document.querySelector('.product-page-quantity');
    if(input?.value ==0){
      document.querySelector('.shopify-payment-button__button')?.setAttribute('disabled','true');
    }else{
      document.querySelector('.shopify-payment-button__button')?.removeAttribute('disabled');
    }
  }

  setSummaryAccessibility(cartDrawerNote) {
    cartDrawerNote.setAttribute('role', 'button');
    cartDrawerNote.setAttribute('aria-expanded', 'false');

    if (cartDrawerNote.nextElementSibling.getAttribute('id')) {
      cartDrawerNote.setAttribute('aria-controls', cartDrawerNote.nextElementSibling.id);
    }

    cartDrawerNote.addEventListener('click', (event) => {
      event.currentTarget.setAttribute('aria-expanded', !event.currentTarget.closest('details').hasAttribute('open'));
    });

    cartDrawerNote.parentElement.addEventListener('keyup', onKeyUpEscape);
  }

  renderContents(parsedState) {
    this.querySelector('.drawer__inner').classList.contains('is-empty') &&
      this.querySelector('.drawer__inner').classList.remove('is-empty');
           document.body.style.pointerEvents = 'none';

      // if (typeof window.CheckAndRemoveFreebies === "function") {
      //   window.CheckAndRemoveFreebies();
      // }

      // window.updateFreeGift();

    // const checkoutButton = document.getElementById('CartDrawer-Checkout');
    // if (checkoutButton) {
    //   checkoutButton.disabled = true;
    // }
    
    this.productId = parsedState.id;
    this.getSectionsToRender().forEach((section) => {
      const sectionElement = section.selector
        ? document.querySelector(section.selector)
        : document.getElementById(section.id);
      sectionElement.innerHTML = this.getSectionInnerHTML(parsedState.sections[section.id], section.selector);
    });


    setTimeout(() => {
      this.querySelector('#CartDrawer-Overlay').addEventListener('click', this.close.bind(this));
      this.open();

       const buyNowButton = document.querySelector('.custom-buy-now');
      if (buyNowButton) {
        buyNowButton.disabled = false;    
        buyNowButton.style.pointerEvents = ""; 
        buyNowButton.style.cursor = "";         
      }
      if (window._skipFreeGiftOnNextRender) {
        window._skipFreeGiftOnNextRender = false;
      } else if (typeof window.isFreeGiftConfigured === 'function' && window.isFreeGiftConfigured() && typeof window.updateFreeGift === 'function') {
        window.updateFreeGift();
      }
      if (typeof window.applyCartLineQuantityError === 'function') {
        window.applyCartLineQuantityError();
        setTimeout(() => window.applyCartLineQuantityError(), 150);
      }
      try {
        if (window.COUPON_SETTINGS?.enabled && typeof window.syncCouponBannerFromDOM === 'function') {
          window.syncCouponBannerFromDOM();
        }
      } catch (e) {}
    

      // const buyNowButton = document.querySelector('.custom-buy-now');
      // if (buyNowButton) {
      //   buyNowButton.disabled = false;    
      //   buyNowButton.style.pointerEvents = ""; 
      //   buyNowButton.style.cursor = "";         
      // }
      // const checkoutButton = document.getElementById('CartDrawer-Checkout');
      // if (checkoutButton) checkoutButton.disabled = true;
      // document.body.style.pointerEvents = "none";
      // setTimeout(() => {
      //   const checkoutButton = document.getElementById('CartDrawer-Checkout');
      //   if (checkoutButton) checkoutButton.disabled = true;
      //   document.body.style.pointerEvents = "none";
      //     // window.NewFreebieAdded();
      //     if (typeof window.NewFreebieAdded === "function") {
      //       window.NewFreebieAdded();
      //     }
      //   // window.handleFreebieAdd();
      // }, 300);
      
    });
  }

  getSectionInnerHTML(html, selector = '.shopify-section') {
    return new DOMParser().parseFromString(html, 'text/html').querySelector(selector).innerHTML;
  }

  getSectionsToRender() {
    return [
      {
        id: 'cart-drawer',
        selector: '#CartDrawer',
      },
      {
        id: 'cart-icon-bubble',
      },
    ];
  }

  getSectionDOM(html, selector = '.shopify-section') {
    return new DOMParser().parseFromString(html, 'text/html').querySelector(selector);
  }

  setActiveElement(element) {
    this.activeElement = element;
  }
}

customElements.define('cart-drawer', CartDrawer);

class CartDrawerItems extends CartItems {
  getSectionsToRender() {
    return [
      {
        id: 'CartDrawer',
        section: 'cart-drawer',
        selector: '.drawer__inner',
      },
      {
        id: 'cart-icon-bubble',
        section: 'cart-icon-bubble',
        selector: '.shopify-section',
      },
    ];
  }
}

customElements.define('cart-drawer-items', CartDrawerItems);


